export const DefaultTheme = {
  colors: {
    primary: '#000000',
    primaryInverted: '#FFFFFF',
    accent: '#FF3347',
    secondary: '#272727',
    decorators: '#669EFF',
    badges: '#C21F4C',
  },
  texts: {
    default: {
      fontFamily: undefined,
      fontWeight: undefined,
      fontStyle: undefined,
      fontSize: undefined,
      lineHeight: undefined,
      letterSpacing: undefined,
    },
    header: {
      fontFamily: undefined,
      fontWeight: undefined,
      fontStyle: undefined,
      fontSize: undefined,
      lineHeight: undefined,
      letterSpacing: undefined,
    },
    buttons: {
      fontFamily: undefined,
      fontWeight: undefined,
      fontStyle: undefined,
      fontSize: undefined,
      lineHeight: undefined,
    },
    descriptions: {
      regular: {
        fontFamily: undefined,
        fontWeight: undefined,
        fontStyle: undefined,
        fontSize: undefined,
        lineHeight: undefined,
      },
      bold: {
        fontFamily: undefined,
        fontWeight: undefined,
        fontStyle: undefined,
        fontSize: undefined,
        lineHeight: undefined,
      },
      light: {
        fontFamily: undefined,
        fontWeight: undefined,
        fontStyle: undefined,
        fontSize: undefined,
        lineHeight: undefined,
      },
    },
    productTileDesktop: {
      title: {
        fontFamily: undefined,
        fontWeight: undefined,
        fontStyle: undefined,
        fontSize: undefined,
        lineHeight: undefined,
      },
      price: {
        fontFamily: undefined,
        fontWeight: undefined,
        fontStyle: undefined,
        fontSize: undefined,
        lineHeight: undefined,
      },
      originalPrice: {
        fontFamily: undefined,
        fontWeight: undefined,
        fontStyle: undefined,
        fontSize: undefined,
        lineHeight: undefined,
        textDecorationLine: undefined,
      },
      salePrice: {
        fontFamily: undefined,
        fontWeight: undefined,
        fontStyle: undefined,
        fontSize: undefined,
        lineHeight: undefined,
      },
      saleBadge: {
        fontFamily: undefined,
        fontWeight: undefined,
        fontStyle: undefined,
        fontSize: undefined,
        lineHeight: undefined,
        textTransform: undefined,
      },
      banner: {
        fontFamily: undefined,
        fontWeight: undefined,
        fontStyle: undefined,
        fontSize: undefined,
        lineHeight: undefined,
        letterSpacing: undefined,
        textTransform: undefined,
      },
      brand: {
        fontFamily: undefined,
        fontWeight: undefined,
        fontStyle: undefined,
        fontSize: undefined,
        lineHeight: undefined,
      },
      small: {
        fontFamily: undefined,
        fontWeight: undefined,
        fontStyle: undefined,
        fontSize: undefined,
        lineHeight: undefined,
      },
      promo: {
        fontFamily: undefined,
        fontWeight: undefined,
        fontStyle: undefined,
        fontSize: undefined,
        lineHeight: undefined,
      },
    },
    productTileMobile: {
      title: {
        fontFamily: undefined,
        fontWeight: undefined,
        fontStyle: undefined,
        fontSize: undefined,
        lineHeight: undefined,
      },
      price: {
        fontFamily: undefined,
        fontWeight: undefined,
        fontStyle: undefined,
        fontSize: undefined,
        lineHeight: undefined,
      },
      originalPrice: {
        fontFamily: undefined,
        fontWeight: undefined,
        fontStyle: undefined,
        fontSize: undefined,
        lineHeight: undefined,
        textDecorationLine: undefined,
      },
      salePrice: {
        fontFamily: undefined,
        fontWeight: undefined,
        fontStyle: undefined,
        fontSize: undefined,
        lineHeight: undefined,
      },
      saleBadge: {
        fontFamily: undefined,
        fontWeight: undefined,
        fontStyle: undefined,
        fontSize: undefined,
        lineHeight: undefined,
        textTransform: undefined,
      },
      banner: {
        fontFamily: undefined,
        fontWeight: undefined,
        fontStyle: undefined,
        fontSize: undefined,
        lineHeight: undefined,
        letterSpacing: undefined,
        textTransform: undefined,
      },
      brand: {
        fontFamily: undefined,
        fontWeight: undefined,
        fontStyle: undefined,
        fontSize: undefined,
        lineHeight: undefined,
      },
      small: {
        fontFamily: undefined,
        fontWeight: undefined,
        fontStyle: undefined,
        fontSize: undefined,
        lineHeight: undefined,
      },
      promo: {
        fontFamily: undefined,
        fontWeight: undefined,
        fontStyle: undefined,
        fontSize: undefined,
        lineHeight: undefined,
      },
    },
  },
  resultsScreen: {
    grid: {
      columns: {
        mobileS: 2,
        laptop: 3,
        laptopM: 4,
      },
    },
  },
};
